import { notificationUtils } from 'features/notifications'
import { appSelectors } from 'redux/reducers/app'
import { NotAuthorizedError } from 'shared/errors'

import store from '../../redux/store'

export function shouldUpgrade(error: Error | string) {
	const isExpired =
		error instanceof NotAuthorizedError &&
		!appSelectors.subscriptionIsActive(store.getState())

	if (isExpired) {
		notificationUtils.snackById('3.17')
	}

	return isExpired
}
